import React, { Component } from 'react';
import { UserContext, urls } from '../../constants';
import i18next from "../../i18n";
import { decodeHTMLEntities } from '../helpers/HelperFunctions';
import { History } from '../helpers/History';
export class CompanySettingsForm extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            companyName: '',
            stampIsRequired: false,
            stampIsRequiredSavedValue: false,
            sending: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }
    handleChange(event) {
        const { name, value, type } = event.target;
        this.setState({ [name]: type === "checkbox" ? event.target.checked : value });
    }
    handleSubmit(event) {
        event.preventDefault();
        const { stampIsRequired } = this.state;
        const { companyId } = this.props;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: companyId, stampIsRequired: stampIsRequired })
        };
        fetch('/account/editCompanySettings', requestOptions)
            .then((response) => {
                if (response.ok) {
                    this.setState({ sending: false, stampIsRequiredSavedValue: stampIsRequired });
                    if (this.props.onSubmitedHandler)
                        this.props.onSubmitedHandler();
                }
                else {
                    if (response.status === 403) {
                        History.push(urls.accessDeniedUrl);
                        return;
                    }
                    else {
                        return response.text().then((errorText) => {
                            console.log(errorText);
                            require('../ModalDialogsTemplates').unknownErrorMessageDialog();
                        });
                    }
                }
            });

    }
    componentDidMount() {
        this.fillForm();
    }
    onCancel() {
        const { onCloseHandler } = this.props;
        if (!this.state.sending && onCloseHandler)
            onCloseHandler();
    }
    render() {
        const { companyName, stampIsRequired, stampIsRequiredSavedValue, sending } = this.state;
        if (companyName) {
            return (<form name="form" className="popupSimple user-invite-form">
                <div className="row">
                    <div className="form-group col-sm-12 col-xs-12">
                        <label htmlFor="companyName">{i18next.t("companyName")}</label>
                        <input type="text" className="form-control" name="companyName" value={companyName} disabled="disabled" />
                    </div>
                    <div className="form-group col-sm-12 col-xs-12">
                        <div className="checkbox-form dialog-form-checkbox">
                            <div>
                                <input id="stampIsRequired" name="stampIsRequired" checked={stampIsRequired} className="form-control" onChange={(e) => this.handleChange(e)} type="checkbox" disabled={(sending ? "disabled" : "")} />
                                <label htmlFor="stampIsRequired">{i18next.t("stampRequiredLabel")}</label>
                            </div>
                        </div>
                    </div>
                </div>,
                <div className="form-group form-group__last">
                    <button className="btn btn-primary" disabled={stampIsRequired === stampIsRequiredSavedValue || sending ? "disabled" : ""} onClick={this.handleSubmit} >{i18next.t("save")}</button>
                    <button type="button" className="btn btn-secondary" disabled={sending ? "disabled" : ""} onClick={this.onCancel}>{i18next.t("cancel")}</button>
                </div>
            </form>);
        }
        else return "";
    }
    async fillForm() {
        const requestOptions = {
            method: 'GET'
        };
        const response = await fetch(`account/getCompanyForEdit?companyId=${this.props.companyId}`, requestOptions);
        if (response.ok) {
            const data = await response.json();
            this.setState({
                companyName: decodeHTMLEntities(data.companyName),
                stampIsRequired: data.stampIsRequired,
                stampIsRequiredSavedValue: data.stampIsRequired
            });
        }
        else {
            require('../ModalDialogsTemplates').unknownErrorMessageDialog();
        }
    }
}
